<template>
  <div class="map-container">
    <img id="map" class="map" src="@/images/pages/kaart.svg" />
    <!--  <div class="marker leeuwarden" @click="selectVestiging('leeuwarden')"></div> -->
    <div class="marker heerde" @click="selectVestiging('heerde')"></div>
    <div class="marker amsterdam" @click="selectVestiging('amsterdam')"></div>
    <div class="marker den-haag" @click="selectVestiging('den-haag')"></div>
    <div class="marker nieuwegein" @click="selectVestiging('nieuwegein')"></div>
    <div class="marker boxtel" @click="selectVestiging('boxtel')"></div>
    <div class="marker beegden" @click="selectVestiging('beegden')"></div>
  </div>
</template>

<script>
export default {
  methods: {
    selectVestiging(shop) {
      this.$emit('select-vestiging', shop)
    }
  }
}
</script>

<style lang="scss" scoped>
#map {
  width: auto;
}
.marker {
  width: 25px;
  height: 25px;
  background: white;
  border-radius: 50%;
  box-shadow: rgba(46, 46, 46, 0.3) 0 0 11px;
  position: absolute;
  cursor: pointer;
  animation: bounce-in 0.6s both;
  transition: all 0.2s;

  &:hover {
    margin-top: -3px;
    margin-left: -3px;
    width: 31px;
    height: 31px;
    animation-fill-mode: none;
    box-shadow: rgba(46, 46, 46, 0.6) 0 0 16px;
  }

  //  opacity: 0;

  &.nieuwegein {
    left: 120px;
    top: 150px;
    animation-delay: 0.2s;
  }

  &.leeuwarden {
    left: 173px;
    top: 27px;
    animation-delay: 0.3s;
  }

  &.heerde {
    left: 185px;
    top: 91px;
    animation-delay: 0.4s;
  }

  /*   &.arnhem {
    left: 182px;
    top: 152px;
    animation-delay: 0.5s;
  } */

  &.boxtel {
    left: 136px;
    top: 215px;
    animation-delay: 0.6s;
  }
  &.den-haag {
    left: 60px;
    top: 161px;
    animation-delay: 0.7s;
  }

  &.amsterdam {
    left: 91px;
    top: 109px;
    animation-delay: 0.8s;
  }

  &.beegden {
    left: 166px;
    top: 265px;
    animation-delay: 1s;
  }

  @keyframes bounce-in {
    0% {
      opacity: 1;
      transform: scale(0);
    }

    50% {
      transform: scale(1.3);
    }

    75% {
      transform: scale(0.8);
    }
    100% {
      transform: scale(1);
    }
  }
}
</style>
